import React, { useEffect, useState } from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import Swal from 'sweetalert2';
import { generateAxiosInstance } from '../hooks/useAuthorizedRequest';
import { generateAxiosInstanceCommon } from '../hooks/useAuthorizedReuestCommon';
import ViewImageAndText from '../components/ViewImageAndText';
import { CModal } from '@coreui/react';
import { useNavigate } from 'react-router-dom';
import Pagination from '../components/Pagination';
import { findIndexById, findPageNumber, deleteItem, SortIcon, searchArray } from '../components/Navigation';
import { cleanHtml, Loader } from '../components/ModalsCommonFunctions';
import { generateAxiosInstanceCommonFileUpload } from '../hooks/useAuthorizedRequestForFileUpload';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import CkEditorField from '../components/CkEditorField';

const UpdateTextBook = () => {
    const authorizedAxios = generateAxiosInstance();
    const authorizedAxiosCommon = generateAxiosInstanceCommon();
    const authorizedAxiosCommonFileUpload = generateAxiosInstanceCommonFileUpload();
    const [questions, setQuestion] = useState("");
    const [editId, setEditId] = useState(null);
    const [syllabusList, setSyllabusList] = useState([]);
    const [subjectList, setSubjectList] = useState([])
    const [topicList, setTopicList] = useState([])
    const [lessonList, setLessonList] = useState([])
    const [subTopicViewtopicList, setSubTopicViewtopicList] = useState([])
    const [visible, setVisible] = useState(false)
    const [modalData, setModalData] = useState("")

    const initialFormState = {
        q_level: '',
        q_type: '',
        question: '',
        option_a: '',
        option_b: '',
        option_c: '',
        option_d: '',
        ans: '',
        sol: ''
    }

    const initialFilterState = {
        syllabusStructureMasterId: '',
        lessonMasterId: '',
        topicMasterId: '',
        subTopicId: '',
        subTopicName: '',
        subjectMasterId: ''
    }

    const [filter, setFilter] = useState(initialFilterState);
    const [editAns, setEditAns] = useState(initialFormState);
    const [visibleImage, setVisibleImage] = useState(false);
    const [modalImageSrc, setModalImageSrc] = useState('');

    const [startIndex, setStartIndex] = useState(null);
    const [currPage, setCurrPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(10);
    const [displayedData, setDisplayedData] = useState([]);
    const [totalPages, setTotalPages] = useState(0);
    const [saveId, setSaveId] = useState(null);
    const [refresh, setRefresh] = useState(true);
    const [addNew, setAddNew] = useState(false);

    const [questionLevelSort, setQuestionLevelSort] = useState(null);
    const [questionTypeSort, setQuestionTypeSort] = useState(null);
    const [questionSort, setQuestionSort] = useState(null);

    const [searchValue, setSearchValue] = useState(null);
    const searchKeys = ["q_level", "q_type", "question", "option_a", "option_b", "option_c", "option_d", "ans"];

    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    const handleNavigate = (route) => {
        navigate(route);
    };

    const onViewImage = (imgSrc) => {
        setModalImageSrc(imgSrc);
        setVisibleImage(true);
    };

    useEffect(() => {
        getSyllabusList();
    }, []);

    useEffect(() => {
        if (searchValue === '' && searchValue !== null) {
            setCurrPage(1);
            setRefresh(!refresh);
        }
    }, [searchValue]);


    const handleEmptySearch = (e) => {
        setSearchValue(e.target.value);
    }

    const handleSearch = async () => {
        if (searchValue !== null) {
            if (filter.syllabusStructureMasterId !== "" && filter.subjectMasterId !== "") {
                let apiUrl = `/get-question-bank?`;

                if (filter.syllabusStructureMasterId) {
                    apiUrl += `syllabusStructureMasterId=${filter.syllabusStructureMasterId}&`;
                }
                if (filter.subjectMasterId) {
                    apiUrl += `subjectMasterId=${filter.subjectMasterId}&`
                }
                if (filter.lessonMasterId) {
                    apiUrl += `lessonMasterId=${filter.lessonMasterId}&`;
                }
                if (filter.topicMasterId) {
                    apiUrl += `topicMasterId=${filter.topicMasterId}&`;
                }
                if (filter.subTopicId) {
                    apiUrl += `subTopicMasterId=${filter.subTopicId}&`;
                }

                apiUrl = apiUrl.replace(/&$/, '');
                setQuestion(await searchArray("A", apiUrl, searchKeys, searchValue.trim(), "data"))
            }
        }
    }

    useEffect(() => {
        if (filter.syllabusStructureMasterId !== "" && filter.subjectMasterId !== "") {
            getQuestionAnswerList();
        }
    }, [filter, refresh]);

    useEffect(() => {
        if (saveId) {
            const pageNumber = findPageNumber(questions, saveId, itemsPerPage);
            setCurrPage(pageNumber);
        }
    }, [saveId, addNew])

    useEffect(() => {
        setTotalPages(Math.ceil(questions.length / itemsPerPage));
        const startIndex = (currPage - 1) * itemsPerPage;
        let endIndex = startIndex + itemsPerPage;

        if (endIndex > questions.length) {
            endIndex = questions.length;
        }
        setStartIndex(startIndex);
        setDisplayedData(questions.slice(startIndex, endIndex));
    }, [questions, currPage, itemsPerPage]);

    const getQuestionAnswerList = () => {
        if (filter.syllabusStructureMasterId !== "" && filter.subjectMasterId !== "") {
            let apiUrl = getApiUrl();

            authorizedAxios && authorizedAxios.get(apiUrl)
                .then(response => {
                    setQuestion(response.data.data)
                    // console.log(response.data.data);
                })
                .catch(error => {
                    const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                    console.error('Error fetching data:', errorMsg);
                });
        }
    }

    const getApiUrl = () => {
        if (filter.syllabusStructureMasterId !== "" && filter.subjectMasterId !== "") {
            let apiUrl = `/get-question-bank?`;

            if (filter.syllabusStructureMasterId) {
                apiUrl += `syllabusStructureMasterId=${filter.syllabusStructureMasterId}&`;
            }
            if (filter.subjectMasterId) {
                apiUrl += `subjectMasterId=${filter.subjectMasterId}&`
            }
            if (filter.lessonMasterId) {
                apiUrl += `lessonMasterId=${filter.lessonMasterId}&`;
            }
            if (filter.topicMasterId) {
                apiUrl += `topicMasterId=${filter.topicMasterId}&`;
            }
            if (filter.subTopicId) {
                apiUrl += `subTopicMasterId=${filter.subTopicId}&`;
            }

            apiUrl = apiUrl.replace(/&$/, '');
            return apiUrl;
        }
    }

    const getList = () => {
        if (filter.syllabusStructureMasterId !== "" && filter.subjectMasterId !== "") {
            let apiUrl = getApiUrl();

            authorizedAxios && authorizedAxios.get(apiUrl)
                .then(response => {
                    setQuestion(response.data.data)
                    setAddNew(!addNew);
                    // console.log(response.data.data);
                })
                .catch(error => {
                    const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                    console.error('Error fetching data:', errorMsg);
                });
        }
    }

    const getSyllabusList = () => {
        const apiUrlForSyllabus = `/get-all-syllabus-structure`;
        authorizedAxiosCommon && authorizedAxiosCommon.get(apiUrlForSyllabus)
            .then(response => {
                setSyllabusList(response.data.result)
            })
            .catch(error => {
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                console.error('Error fetching data:', errorMsg);
            });
    }

    const handleSyllabusChange = (e) => {
        setFilter((prevData) => {
            return {
                ...prevData,
                [e.target.name]: e.target.value,
                lessonMasterId: '',
                topicMasterId: '',
                subTopicId: '',
                subjectMasterId: ''
            }
        })
        setLessonList([])

        const apiUrl2 = `/syllabus-structure-wise-subjects?id=${e.target.value}`;
        authorizedAxios && authorizedAxios.get(apiUrl2)
            .then(response => {
                setSubjectList(response.data.result)
            })
            .catch(error => {
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                console.error('Error fetching data:', errorMsg);
            });
    }

    const handleSubjectChange = (e) => {
        setFilter((prevData) => {
            return {
                ...prevData,
                [e.target.name]: e.target.value,
                lessonMasterId: '',
                topicMasterId: '',
                subTopicId: '',
            }
        })
        const apiUrl = `/subject-wise-lesson?syllabusStructureMasterId=${filter.syllabusStructureMasterId}&subjectMasterId=${e.target.value}`;
        authorizedAxios && authorizedAxios.get(apiUrl)
            .then(response => {
                setLessonList(response.data.result)
            })
            .catch(error => {
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                console.error('Error fetching data:', errorMsg);
            });
    }

    const handleLessonChange = (e) => {
        setFilter((prevData) => {
            return {
                ...prevData,
                [e.target.name]: e.target.value,
                topicMasterId: '',
                subTopicId: ''
            }
        })
        const apiUrl = `/lesson-wise-topic?id=${e.target.value}`;
        authorizedAxios && authorizedAxios.get(apiUrl)
            .then(response => {
                setTopicList(response.data.result)
            })
            .catch(error => {
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                console.error('Error fetching data:', errorMsg);
            });
    }

    const handleTopicChange = (e) => {
        setFilter((prevData) => {
            return {
                ...prevData,
                [e.target.name]: e.target.value,
                subTopicId: ''
            }
        })
        const apiUrl = `/get-sub-topic-master-list?syllabusStructureId=${filter.syllabusStructureMasterId}&subjectMasterId=${filter.subjectMasterId}&lessonId=${filter.lessonMasterId}&topicId=${e.target.value}`;
        authorizedAxios && authorizedAxios.get(apiUrl)
            .then(response => {
                setSubTopicViewtopicList(response.data.result)
            })
            .catch(error => {
                console.error('Error fetching data:', error);
                setSubTopicViewtopicList([])
            });
    }

    const handleInputChangeFilter = (e) => {
        setFilter((prevData) => {
            return {
                ...prevData,
                [e.target.name]: e.target.value
            }
        })
    }

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setEditAns((prevData) => {
            return {
                ...prevData,
                [name]: value
            }
        })
    }

    const deleteSubtopic = (id) => {
        let confirmed = window.confirm('Are you sure? you want to delete this record.');
        if (confirmed) {
            setLoading(true);
            const apiUrl = `/delete-question-bank?id=${id}`;
            authorizedAxios && authorizedAxios.delete(apiUrl)
                .then(response => {
                    const page = deleteItem(currPage, itemsPerPage, questions.length);
                    setRefresh(!refresh);
                    setCurrPage(page);

                    Swal.fire(
                        { text: response.data.message }
                    );
                })
                .catch(error => {
                    const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                    Swal.fire(
                        { text: errorMsg }
                    );
                })
                .finally(() => {
                    setLoading(false); // End loading
                });
        }
    }

    // const cleanHtml = (html) => {
    //     if (!html) return '';

    //     // Replace &nbsp; with space
    //     html = html.replace(/&nbsp;/g, ' ');

    //     // Remove all tags except <img>
    //     html = html.replace(/<(?!img\b)[^>]*>/gi, '');

    //     return html.trim();
    // };

    const updateSubtopic = () => {
        setLoading(true);
        const apiUrl = `/edit-question-bank?id=${editId}`;

        // Clean fields in one go
        const fieldsToClean = ['question', 'option_a', 'option_b', 'option_c', 'option_d', 'sol'];
        const cleanedFields = {};

        fieldsToClean.forEach(field => {
            cleanedFields[field] = cleanHtml(editAns[field] || '');
        });

        const payload = {
            ...editAns,
            ...cleanedFields
        };

        authorizedAxios && authorizedAxios.put(apiUrl, payload)
            .then(response => {
                getList();
                setSaveId(response.data.result.id);
                setEditAns(initialFormState)
                setEditId(null);

                Swal.fire(
                    { text: response.data.message }
                );
            })
            .catch(error => {
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                Swal.fire(
                    { text: errorMsg }
                );
            })
            .finally(() => {
                setLoading(false); // End loading
            });
    }

    const handleCkChange = (fieldName, editor) => {
        const value = editor.getData();
        setEditAns((prev) => ({
            ...prev,
            [fieldName]: value
        }));
    };

    function uploadAdapter(loader) {
        return {
            upload: () => {
                return new Promise((resolve, reject) => {
                    const body = new FormData();
                    loader.file.then(async (file) => {
                        body.append("file", file);
                        const apiUrl = "uploadimage";
                        authorizedAxiosCommonFileUpload && authorizedAxiosCommonFileUpload.post(apiUrl, body)
                            .then((res) => {
                                resolve({ default: res.data.result });
                            })
                            .catch((err) => {
                                reject(err.response.data.message);
                            });
                    });
                });
            },
        };
    }

    function uploadPlugin(editor) {
        editor.plugins.get("FileRepository").createUploadAdapter = (loader) => {
            return uploadAdapter(loader);
        };
    }

    useEffect(() => {
        if (questionLevelSort == true || questionLevelSort == false) {
            setQuestionTypeSort(null);
            setQuestionSort(null);
        }
    }, [questionLevelSort])

    useEffect(() => {
        if (questionTypeSort == true || questionTypeSort == false) {
            setQuestionLevelSort(null);
            setQuestionSort(null);
        }
    }, [questionTypeSort])

    useEffect(() => {
        if (questionSort == true || questionSort == false) {
            setQuestionLevelSort(null);
            setQuestionTypeSort(null);
        }
    }, [questionSort])

    return (
        <>
            <Loader loading={loading} />
            <div className="wrapper d-flex flex-column min-vh-100 bg-light">
                <div id='scroll-up'></div>
                <Header />
                <div className="container-fluid">
                    <nav aria-label="breadcrumb">
                        <ol className="breadcrumb my-0 ms-2">
                            <li className="breadcrumb-item dashboard" onClick={() => handleNavigate('/dashboard')}>
                                <span>Dashboard</span>
                            </li>
                            <li className="breadcrumb-item active"><span>Update Text Book Question Bank</span></li>
                        </ol>
                    </nav>
                </div>

                <div className="container-lg">
                    <div className="row">
                        <div className="card border-info mx-auto mt-3">
                            <div className="card-content collpase show">
                                <div className="card-header" style={{ backgroundColor: '#3081D0', borderRadius: 0 }}>
                                    <h4 className="text-white"><b><span className="fa fa-file-o"></span><i class="fa fa-eye"></i>Update Text Book Question Bank</b></h4>
                                </div>
                                <div className="card-body ">
                                    <div className="row">
                                        <div className="col-md-12">
                                            <div className="row">
                                                <div className="col-md-6">
                                                    <label for="inputPassword" className="col-form-label">Select Syllabus Structure :</label>
                                                    <select required class="form-select" aria-label="Default select example" name='syllabusStructureMasterId' onChange={handleSyllabusChange} value={filter.syllabusStructureMasterId}>
                                                        <option selected value={''}>Select Syllabus</option>
                                                        {
                                                            syllabusList?.map((syllabus) => {
                                                                return <option value={syllabus.id}>{syllabus?.syllabusStructureName}</option>
                                                            })
                                                        }
                                                    </select>
                                                </div>

                                                <div className="col-md-6">
                                                    <label for="inputPassword" className="col-form-label">Select Subject :</label>
                                                    <select required class="form-select" aria-label="Default select example" name='subjectMasterId' onChange={handleSubjectChange} value={filter.subjectMasterId}>
                                                        <option selected value={''} disabled>Select Subject</option>
                                                        {
                                                            subjectList?.map((syllabus) => {
                                                                return <option value={syllabus.subjectMasterDetails.id}>{syllabus.subjectMasterDetails.subjectName}</option>
                                                            })
                                                        }
                                                    </select>
                                                </div>

                                                <div className="col-md-6">
                                                    <label for="inputPassword" className="col-form-label">Select Lesson :</label>
                                                    <select required class="form-select" aria-label="Default select example" name='lessonMasterId' onChange={handleLessonChange} value={filter.lessonMasterId}>
                                                        <option selected value={''} disabled>Select Lesson</option>
                                                        {
                                                            lessonList?.map((lesson) => {
                                                                return <option value={lesson.id}>{lesson.lessonName}</option>
                                                            })
                                                        }
                                                    </select>
                                                </div>
                                                <div className="col-md-6">
                                                    <label for="inputPassword" className="col-form-label">Select Topic :</label>
                                                    <select required class="form-select" aria-label="Default select example" name='topicMasterId' onChange={handleTopicChange} value={filter.topicMasterId}>
                                                        <option selected value={''} disabled>Select Topic</option>
                                                        {
                                                            topicList?.map((topic) => {
                                                                return <option value={topic.id}>{topic.topicName}</option>
                                                            })
                                                        }
                                                    </select>
                                                </div>

                                                <div className="col-md-6">
                                                    <label for="inputPassword" className="col-form-label">Select Sub Topic :</label>
                                                    <select required class="form-select" aria-label="Default select example" name='subTopicId' onChange={handleInputChangeFilter} value={filter.subTopicId}>
                                                        <option selected value={''} disabled>Select Sub Topic</option>
                                                        {
                                                            subTopicViewtopicList?.map((topic) => {
                                                                return <option value={topic.id}>{topic.subTopicName}</option>
                                                            })
                                                        }
                                                    </select>
                                                </div>

                                                {!editId && <div className="col-md-12 mt-3 mb-1" style={{ textAlign: 'center' }}>
                                                    <div className="col-auto">
                                                        <button className="btn btn-outline-danger delete_icon" type="button" style={{ marginRight: '20px' }} onClick={() => { setFilter(initialFilterState) }}>Reset</button>
                                                    </div>
                                                </div>}


                                                {editAns.question !== '' && <>
                                                    {/* <div className='row'> */}
                                                    <div className="col-md-6">
                                                        <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Question Level :</label>
                                                        <input required type="text" className="form-control" id="q_level" name='q_level' onChange={handleInputChange} value={editAns.q_level} />
                                                    </div>
                                                    <div className="col-md-6">
                                                        <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Question Type :</label>
                                                        <input required type="text" className="form-control" id="q_type" name='q_type' onChange={handleInputChange} value={editAns.q_type} />
                                                    </div>
                                                    {/* </div> */}

                                                    {/* <div className='row'> */}
                                                    {/* <div className="col-md-12"> */}
                                                    {/* <label for="question" className="col-form-label"><span style={{ color: "red" }}>*</span>Question :</label> */}
                                                    {/* <textarea required type="text" className="form-control" id="question" name='question' onChange={handleInputChange} value={editAns.question} /> */}
                                                    {/* <CKEditor
                                                                editor={ClassicEditor}
                                                                data={editAns.question}
                                                                onChange={(event, editor) => handleCkChange("question", editor)}
                                                                config={{ extraPlugins: [uploadPlugin] }}
                                                                onInit={(editor) => { uploadPlugin(editor) }}
                                                            />
                                                        </div> */}
                                                    <CkEditorField label="Question" name="question" value={editAns.question} handleChange={handleCkChange} uploadPlugin={uploadPlugin} />
                                                    {/* </div> */}

                                                    {/* <div className='row'> */}
                                                    {/* <div className="col-md-12"> */}
                                                    {/* <label for="option_a" className="col-form-label"><span style={{ color: "red" }}>*</span>Option A :</label> */}
                                                    {/* <textarea required type="text" className="form-control" id="option_a" name='option_a' onChange={handleInputChange} value={editAns.option_a} /> */}
                                                    {/* <CKEditor
                                                                editor={ClassicEditor}
                                                                data={editAns.option_a}
                                                                onChange={(event, editor) => handleCkChange("option_a", editor)}
                                                                config={{ extraPlugins: [uploadPlugin] }}
                                                                onInit={(editor) => { uploadPlugin(editor) }}
                                                            /> */}
                                                    {/* </div> */}

                                                    <CkEditorField label="Option A" name="option_a" value={editAns.option_a} handleChange={handleCkChange} uploadPlugin={uploadPlugin} />

                                                    {/* <div className="col-md-12">
                                                            <label for="option_b" className="col-form-label"><span style={{ color: "red" }}>*</span>Option B :</label> */}
                                                    {/* <input required type="text" className="form-control" id="option_b" name='option_b' onChange={handleInputChange} value={editAns.option_b} /> */}
                                                    {/* <CKEditor
                                                                editor={ClassicEditor}
                                                                data={editAns.option_b}
                                                                onChange={(event, editor) => handleCkChange("option_b", editor)}
                                                                config={{ extraPlugins: [uploadPlugin] }}
                                                                onInit={(editor) => { uploadPlugin(editor) }}
                                                            />
                                                        </div> */}

                                                    <CkEditorField label="Option B" name="option_b" value={editAns.option_b} handleChange={handleCkChange} uploadPlugin={uploadPlugin} />

                                                    {/* <div className="col-md-12">
                                                            <label for="option_c" className="col-form-label"><span style={{ color: "red" }}>*</span>Option C :</label> */}
                                                    {/* <input required type="text" className="form-control" id="option_c" name='option_c' onChange={handleInputChange} value={editAns.option_c} /> */}
                                                    {/* <CKEditor
                                                                editor={ClassicEditor}
                                                                data={editAns.option_c}
                                                                onChange={(event, editor) => handleCkChange("option_c", editor)}
                                                                config={{ extraPlugins: [uploadPlugin] }}
                                                                onInit={(editor) => { uploadPlugin(editor) }}
                                                            />
                                                        </div> */}

                                                    <CkEditorField label="Option C" name="option_c" value={editAns.option_c} handleChange={handleCkChange} uploadPlugin={uploadPlugin} />

                                                    {/* <div className="col-md-12">
                                                            <label for="option_d" className="col-form-label"><span style={{ color: "red" }}>*</span>Option D :</label> */}
                                                    {/* <input required type="text" className="form-control" id="option_d" name='option_d' onChange={handleInputChange} value={editAns.option_d} /> */}
                                                    {/* <CKEditor
                                                                editor={ClassicEditor}
                                                                data={editAns.option_d}
                                                                onChange={(event, editor) => handleCkChange("option_d", editor)}
                                                                config={{ extraPlugins: [uploadPlugin] }}
                                                                onInit={(editor) => { uploadPlugin(editor) }}
                                                            />
                                                        </div> */}

                                                    <CkEditorField label="Option D" name="option_d" value={editAns.option_d} handleChange={handleCkChange} uploadPlugin={uploadPlugin} />

                                                    {/* <div className='row'> */}
                                                    <div className="col-md-12">
                                                        <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Answer :</label>
                                                        <input required type="text" className="form-control" id="ans" name='ans' onChange={handleInputChange} value={editAns.ans} />
                                                    </div>
                                                    {/* <div className="col-md-12">
                                                                <label for="sol" className="col-form-label"><span style={{ color: "red" }}>*</span>Solution :</label> */}
                                                    {/* <input required type="text" className="form-control" id="sol" name='sol' onChange={handleInputChange} value={editAns.sol} /> */}
                                                    {/* <CKEditor
                                                                    editor={ClassicEditor}
                                                                    data={editAns.sol}
                                                                    onChange={(event, editor) => handleCkChange("sol", editor)}
                                                                    config={{ extraPlugins: [uploadPlugin] }}
                                                                    onInit={(editor) => { uploadPlugin(editor) }}
                                                                />
                                                            </div> */}

                                                    <CkEditorField label="Solution" name="sol" value={editAns.sol} handleChange={handleCkChange} uploadPlugin={uploadPlugin} />

                                                    {/* </div> */}
                                                    {/* </div> */}


                                                    <div className="col-md-12 mt-3 mb-1" style={{ textAlign: 'center' }}>

                                                        <div className="col-auto">
                                                            <button className="btn btn-primary" type="button" style={{ marginRight: '20px' }} onClick={() => updateSubtopic()} >Update</button>
                                                            <button className="btn btn-outline-danger delete_icon" type="button" style={{ marginRight: '20px' }} onClick={() => { setEditAns(initialFormState); setEditId(null) }}>Reset</button>
                                                        </div>
                                                    </div>
                                                </>}

                                                {visible && <CModal
                                                    visible={visible}
                                                    onClose={() => setVisible(false)}
                                                    aria-labelledby="LiveDemoExampleLabel"
                                                    onIni
                                                >
                                                    <div className="book book-modal">
                                                        <h2 className='table-header-like'> Solution</h2>
                                                        <div className="page no-error-class" dangerouslySetInnerHTML={{
                                                            __html: `<style>.ckContent img{max-width:100% !important; height: auto !important}</style><div class="ck-content">${modalData === null ? "No Solution Found" : modalData}</div>`
                                                        }}></div>

                                                        <button className="btn btn-outline-warning edit_icon" type="button" onClick={() => setVisible(false)}>
                                                            Close
                                                        </button>
                                                    </div>
                                                </CModal>}

                                                {visibleImage && (
                                                    <CModal
                                                        visible={visibleImage}
                                                        onClose={() => setVisibleImage(false)}
                                                        aria-labelledby="LiveDemoExampleLabel"
                                                    >
                                                        <div className="book book-modal">
                                                            <div className='table-header-like'>Image</div>
                                                            {modalImageSrc && <div className='page' dangerouslySetInnerHTML={{ __html: modalImageSrc }}></div>}
                                                            <button className="btn btn-outline-warning edit_icon" type="button" onClick={() => setVisibleImage(false)}>
                                                                Close
                                                            </button>
                                                        </div>
                                                    </CModal>
                                                )}

                                                {filter.subjectMasterId !== "" &&
                                                    <div className="d-grid gap-2 mt-2">
                                                        <div className='tab-content rounded-bottom custom_table custom_table_width'>
                                                            <div className='search_btn_row'>
                                                                <input
                                                                    className="form-control mr-sm-2"
                                                                    type="Search"
                                                                    placeholder="Search"
                                                                    value={searchValue}
                                                                    onChange={handleEmptySearch}
                                                                    onKeyDown={(event) => {
                                                                        if (event.key === 'Enter') {
                                                                            handleSearch();
                                                                        }
                                                                    }}
                                                                />
                                                                <button className="btn btn-outline-primary" onClick={handleSearch}><i class="fa fa-search" aria-hidden="true"></i></button>
                                                            </div>
                                                            <div class="tab-pane p-3 active prefilter" role="tabpanel" id="prefilter-1000">
                                                                <table class="table">
                                                                    <thead>
                                                                        <tr>
                                                                            <th scope="col" className='sl_no'>Sr. No.</th>
                                                                            <th scope='col'>
                                                                                Q_Level
                                                                                <SortIcon sortState={questionLevelSort} setSortState={setQuestionLevelSort} setData={setQuestion} setCurrPage={setCurrPage} sortingPath={"q_level"} />
                                                                            </th>
                                                                            <th scope='col'>
                                                                                Q_Type
                                                                                <SortIcon sortState={questionTypeSort} setSortState={setQuestionTypeSort} setData={setQuestion} setCurrPage={setCurrPage} sortingPath={"q_type"} />
                                                                            </th>
                                                                            <th scope='col'>
                                                                                Question
                                                                                <SortIcon sortState={questionSort} setSortState={setQuestionSort} setData={setQuestion} setCurrPage={setCurrPage} sortingPath={"question"} />
                                                                            </th>
                                                                            <th scope="col">Option_a</th>
                                                                            <th scope="col">Option_b </th>
                                                                            <th scope="col">Option_c</th>
                                                                            <th scope="col">Option_d</th>
                                                                            <th scope='col'>Answer</th>
                                                                            <th scope='col'>Solution</th>
                                                                            <th scope='col'>Action</th>
                                                                        </tr>
                                                                    </thead>
                                                                    <tbody>
                                                                        {
                                                                            displayedData?.length > 0 ?
                                                                                displayedData?.map((question, index) => {
                                                                                    return (
                                                                                        <tr key={index}>
                                                                                            <th scope="row" className='sl_no'>{startIndex + index + 1}</th>
                                                                                            <td>{question.q_level}</td>
                                                                                            <td>{question.q_type}</td>
                                                                                            {/* <ViewImageAndText inputString={question.question} onViewImage={onViewImage} />
                                                                                            <ViewImageAndText inputString={question.option_a} onViewImage={onViewImage} />
                                                                                            <ViewImageAndText inputString={question.option_b} onViewImage={onViewImage} />
                                                                                            <ViewImageAndText inputString={question.option_c} onViewImage={onViewImage} />
                                                                                            <ViewImageAndText inputString={question.option_d} onViewImage={onViewImage} /> */}
                                                                                            <td><div dangerouslySetInnerHTML={{ __html: question.question }} /></td>
                                                                                            <td><div dangerouslySetInnerHTML={{ __html: question.option_a }} /></td>
                                                                                            <td><div dangerouslySetInnerHTML={{ __html: question.option_b }} /></td>
                                                                                            <td><div dangerouslySetInnerHTML={{ __html: question.option_c }} /></td>
                                                                                            <td><div dangerouslySetInnerHTML={{ __html: question.option_d }} /></td>
                                                                                            <td>{question.ans}</td>
                                                                                            <td>
                                                                                                <button className="btn btn-primary view_icon mt-1" type="button" onClick={() => {
                                                                                                    setVisible(!visible)
                                                                                                    setModalData(question.sol)
                                                                                                }}><i class="fa fa-eye" ></i></button>
                                                                                            </td>
                                                                                            <td>
                                                                                                <button className="btn btn-outline-warning edit_icon" type="button" style={{ marginRight: '5px' }}
                                                                                                    onClick={() => {
                                                                                                        setEditId(question.id);
                                                                                                        setEditAns({
                                                                                                            q_level: question.q_level,
                                                                                                            q_type: question.q_type,
                                                                                                            question: question.question,
                                                                                                            option_a: question.option_a,
                                                                                                            option_b: question.option_b,
                                                                                                            option_c: question.option_c,
                                                                                                            option_d: question.option_d,
                                                                                                            ans: question.ans,
                                                                                                            sol: question.sol
                                                                                                        });
                                                                                                        document.getElementById('scroll-up').scrollIntoView({ behavior: 'smooth' });
                                                                                                    }}
                                                                                                ><i class="fa-light fa-pen-to-square"></i></button>
                                                                                                <button className="btn btn-outline-danger delete_icon" type="button" disabled={editId === question.id} onClick={() => deleteSubtopic(question.id)}> <i class="fa-light fa-trash-can"></i></button>
                                                                                            </td>
                                                                                        </tr>
                                                                                    )
                                                                                })
                                                                                :
                                                                                (<tr>
                                                                                    <th colspan={"100%"} style={{ textAlign: 'center' }}>No Questions Available</th>
                                                                                </tr>)
                                                                        }
                                                                    </tbody>
                                                                </table>

                                                                <Pagination currPage={currPage} setCurrPage={setCurrPage} totalPages={totalPages} itemsPerPage={itemsPerPage} setItemsPerPage={setItemsPerPage} totalItem={questions.length} />

                                                            </div>
                                                        </div>
                                                    </div>
                                                }
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </>
    )
};

export default UpdateTextBook;
